import { render, staticRenderFns } from "./BiokaminoLogo.vue?vue&type=template&id=6739f746&scoped=true&"
var script = {}
import style0 from "./BiokaminoLogo.vue?vue&type=style&index=0&id=6739f746&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6739f746",
  null
  
)

export default component.exports